/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Returnairhumiditydefect3Inputs */



/**
* | output |
* | --- |
* | "Return air humidity sensor fault" |
*
* @param {Ahu_History_Key_Returnairhumiditydefect3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_returnairhumiditydefect3 = /** @type {((inputs?: Ahu_History_Key_Returnairhumiditydefect3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Returnairhumiditydefect3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Return air humidity sensor fault")
	return /** @type {LocalizedString} */ ("Défaut sonde hygrométrie air reprise")
});
export { ahu_history_key_returnairhumiditydefect3 as "ahu_history_key_returnAirHumidityDefect" }